import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/observatorio")({
  head: () => labHead(
    "/lab/observatorio",
    "Observatório",
    "Observatório: painel de pesquisa sobre sofrimento, território, ciência e cuidado, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: ObservatoryLab,
});

function ObservatoryLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/observatorio/" title={{ pt: "Observatório", en: "Observatory", es: "Observatorio" }} />;
}